<template>
  <modal
    :visible="isVisible"
    allow-close
    class="antibot-modal__wrap"
    @on-close="isVisible = false"
  >
    <div class="antibot-modal">
      <div class="antibot-modal__icon">
        <f-sprite-icon
          :icon-link="Sad"
        />
      </div>

      <div class="antibot-modal__title">
        Доступ к сайту заблокирован
      </div>
      <p class="antibot-modal__text">
        Пожалуйста, попробуйте обновить страницу или перейти на главную.
      </p>
      <p class="antibot-modal__text">
        В случае повторного возникновения ошибки свяжитесь со службой поддержки пользователей FUNDAY
        по телефону <ui-link class="antibot-modal__link" href="tel:8 800 770-01-01">
          8&nbsp;800&nbsp;770-01-01
        </ui-link>
        (по России бесплатно),
        <br>
        с 7:00 до 22:00 (мск) и сообщите URL блокировки, ID события и ваш IP-адрес
      </p>
      <p class="antibot-modal__text_data">
        ID события: {{ incidentData?.incidentId }},<br>
        Web-сайт: {{ incidentData?.hostName }},<br>
        Запрос: {{ incidentData?.request }},<br>
        URL: {{ incidentData?.uri }},<br>
        Код ошибки: {{ incidentData?.errorCode }},<br>
        Время: {{ incidentData?.timeUtc }},<br>
        IP-адрес: {{ incidentData?.clientIp }}
      </p>
    </div>
  </modal>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import Sad from '@images/sad.multi.svg';

import { CustomEventName } from '@/constants/custom-event-name';

import { type IQratorIncidentData } from './types';

const isVisible = ref(false);

const incidentData = ref<IQratorIncidentData>();
function showModal(e: CustomEvent<IQratorIncidentData>) {
  isVisible.value = true;
  incidentData.value = e.detail;
}

onMounted(() => {
  document.addEventListener(CustomEventName.IncidentIdError, showModal);
});

onUnmounted(() => {
  document.removeEventListener(CustomEventName.IncidentIdError, showModal);
});

</script>

<style lang="scss">
  .antibot-modal {
    text-align: center;
    padding: 0 4px;

    @include breakpoint("desktop") {
      max-width: 392px;
      padding: 24px 16px 6px;
    }

    &__icon {
      width: 64px;
      height: 64px;
      margin-bottom: 16px;
      display: inline-block;
    }

    &__title {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 4px;

      @include breakpoint("desktop") {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 8px;
      }
    }

    &__text,
    &__text_data {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 4px;

      @include breakpoint("desktop") {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
      }
    }

    &__text_data {
      color: $gray;
      margin-bottom: 0;

      @include breakpoint("desktop") {
        margin-bottom: 0;
      }
    }

    &__link {
      white-space: nowrap;
    }
  }
</style>
